export enum StatusEnum {
    DRAFT = 'draft',
    SUBMITTED = 'submitted',
    INPROGRESS = 'in-progress',
    WITHDRAWN = 'withdrawn',
    IMPLEMENTED = 'implemented',
    DENIED = 'denied',
}
